import React, {MouseEvent} from 'react';
import cx from 'classnames';
import {Icon, PriorityIcon} from '@priority-software/priority-style-react';
import {ModernTooltip} from '../../../../../../../../components/Common/Tooltip/ModernTooltip';
import {ruleDialogID} from '../../../../../../constants';
import {texts} from '../../../../../../texts';
import styles from './functionIcon.module.scss';

type Props = {
    openFunctionDialog: (e: MouseEvent<HTMLElement>) => void;
    componentClasses?: string;
};

export const FunctionIcon = (props: Props) => {
    const {openFunctionDialog, componentClasses} = props;

    return (
        <div className={cx(styles.functionToggle, componentClasses)} onClick={openFunctionDialog}>
            <ModernTooltip
                tooltip={texts.function_icon_tooltip}
                position="top-end"
                portalId={ruleDialogID}
                arrowOffset={8}
            >
                <Icon
                    iconColor="primary-700"
                    componentClasses={styles.icon}
                    icon={PriorityIcon.function}
                />
            </ModernTooltip>
        </div>
    );
};
